import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import {useContext, useRef, useState} from 'react'
import {FaChevronDown} from "react-icons/fa";
import {WorkScheduleContext} from "../context/work-schedule-context.jsx";

const DraggableButtonDropdown = ({team}) => {
    const {setTeams, setIsDragging} = useContext(WorkScheduleContext);
    const [turn, setTurn] = useState({id: null,
                                                    value: team?.schedule?.length === 1 ? "unique" : "SELECTION",
                                                    name: team?.schedule?.length === 1 ? "Turno único" : "Selecione o turno"});
    const btnRef = useRef(null);

    if (!team?.schedule) return null;

    const turns = Array.from({length: team.schedule.length}).map((_, index) => {
        return {id: index,
                value: team.schedule.length === 1 ? "unique" : "T"+(index+1),
                name: team.schedule.length === 1 ? "Turno único" : "Turno "+(index+1),
                scheduleIndex: index
        }
    })

    const handleDragStart = (e, team, period) => {
        setIsDragging(true)
        e.dataTransfer.setData("json/application", JSON.stringify({ team, period }));
    };

    const onDragEnd = () => {
        setIsDragging(false)
    }

    const handleTurn = (turn) => {
        setTurn(turn);
        setTeams(prevContextTeam => {
            return prevContextTeam.map(currentTeamInMap => {
                if (currentTeamInMap.id === team.id) {
                    return {...currentTeamInMap,
                               period: turn.value,
                               turnInitialHour: currentTeamInMap.schedule[turn.scheduleIndex ?? 0].startTime
                    };
                }
                return currentTeamInMap;
            });
        });
    };

    const isSelection = turn.value === "SELECTION";
    const canDrag = team.schedule.length === 1 || !isSelection;

    return (
        <div ref={btnRef}
             className={
                 `mx-auto relative flex items-center justify-between rounded px-1 w-[90%] 
                ${isSelection
                     ? "cursor-not-allowed bg-white border border-[#063A6C] text-[#063A6C]"
                     : "cursor-grab bg-[#063A6C] hover:bg-[#264A6D] text-white"
                 }`
             }
             draggable={canDrag}
             onDragEnd={onDragEnd}
             onDragStart={(e) => {
                 if (btnRef.current) {
                     const clone = btnRef.current.cloneNode(true);
                     clone.style.width = "120px";
                     clone.style.height = "34px";
                     clone.style.position = "absolute";
                     document.body.appendChild(clone);

                     e.dataTransfer.setDragImage(clone, 0, 0);
                     e.currentTarget.addEventListener("dragend", () => {
                         if (clone.parentNode) document.body.removeChild(clone);
                     }, { once: true });
                 }
                 handleDragStart(e, team, turn.value)
             }}
        >
            <span className={"p-2"} >{turn.name}</span>
            <Listbox value={turn} onChange={handleTurn}>
                {
                    team.schedule.length > 1 &&
                    <ListboxButton className="outline-none border-none bg-transparent p-2 cursor-pointer">
                        <div>
                            <FaChevronDown color={isSelection ? "#063A6C" :"#fff"} aria-hidden="true"/>
                        </div>
                    </ListboxButton>
                }
                <ListboxOptions anchor="bottom"
                                className={`mt-2 p-2 rounded-md border border-[#264A6D] outline-none 
                                ${isSelection ? "bg-white text-[#063A6C]"
                                              : "bg-[#063A6C] text-white"
                                            }`
                }>
                    {turns.map((t) => (
                        <ListboxOption
                            className={`p-[2px] rounded cursor-pointer + ${isSelection ? " hover:bg-[#ededed]" : " hover:bg-[#264A6D]"}`}
                            key={t.id}
                            value={t}
                        >
                            {t.name}
                        </ListboxOption>
                    ))}
                </ListboxOptions>
            </Listbox>
        </div>
    )
}

export default DraggableButtonDropdown;